<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close(false)"></button>
    </template>
    <template v-slot:body>
      <div class="row p-3">
        <div class="col custom-name">
          <p>{{ staticImage.name }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2 custom-static-image">
          <span class="badge rounded-pill custom-pill custom-pill-position">{{
            staticImage.id
          }}</span>
          <img
            :src="staticImage.image"
            class="custom-image"
            :class="{ 'custom-image-2': staticImage.id > 3 }"
          />
        </div>
        <div class="col">
          <!-- Actions -->
          <div class="row p-3 justify-content-center">
            <div class="col custom-actions">
              <select v-model="camera" class="form-select custom-select-camera">
                <option>-- Select Device --</option>
                <option
                  v-for="item in devices"
                  :key="item.deviceId"
                  :value="item.deviceId"
                >
                  {{ item.label }}
                </option>
              </select>
              <!-- <button
                type="button"
                class="btn btn-success ms-2"
                :disabled="isSave || deviceId === null"
                @click="startCamera"
              >
                Start Camera
              </button> -->
              <button
                type="button"
                class="btn btn-primary ms-2"
                :disabled="!isStart"
                @click="capturePhoto"
              >
                Capture Photo
              </button>
              <!-- <button
                type="button"
                class="btn btn-danger ms-2"
                :disabled="!isSave"
                @click="stopCamera"
              >
                Turn Camera Off
              </button> -->
            </div>
          </div>
          <!-- Camera -->
          <div v-show="isStart" class="row">
            <div class="col">
              <web-cam
                ref="webcam"
                :device-id="deviceId"
                width="500"
                height="500"
                @started="onStarted"
                @stopped="onStopped"
                @error="onError"
                @cameras="onCameras"
                @camera-change="onCameraChange"
              />
            </div>
          </div>
          <!-- Image -->
          <div v-show="isSave" class="row">
            <div class="col">
              <img :src="capturedImage" class="img-responsive" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              type="button"
              class="btn btn-primary me-2"
              :disabled="!isSave"
              @click="save"
            >
              Keep
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import ZDialog from '@/Components/ZElements/Dialog'
import WebCam from '@/Components/ZElements/WebCam'
export default {
  name: 'client-measurement-take-photo-dialog',
  components: {
    ZDialog,
    WebCam,
  },
  props: {
    show: Object,
  },
  data() {
    return {
      modalSize: 'modal-lgr',
      isSave: false,
      isStart: false,
      capturedImage: null,
      camera: null,
      deviceId: null,
      devices: [],
    }
  },
  emits: ['close', 'save'],
  watch: {
    camera: function (id) {
      this.deviceId = id
      setTimeout(() => {
        this.startCamera()
      }, 300)
    },
    devices: function () {
      // Once we have a list select the first one
      // eslint-disable-next-line no-unused-vars
      const [first, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    },
  },
  mounted() {
    this.init()
  },
  beforeUnmount() {
    this.stopCamera()
  },
  computed: {
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId)
    },
    staticImage() {
      let _image = null
      if (this.show) {
        let found = this.show.rows.find(
          (x) => parseInt(x.id) === parseInt(this.show.row)
        )
        if (found) {
          _image = found
        }
      }
      return _image
    },
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Take Progress Photo'
      return _title
    },
  },
  methods: {
    init() {
      this.capturedImage = null
      this.camera = null
      this.deficeId = null
      this.isSave = false
      this.isStart = false
      if (this.devices.length > 0) {
        this.startCamera()
      }
    },
    stop() {
      this.capturedImage = null
      this.camera = null
      this.deficeId = null
      this.isSave = false
      this.isStart = false
      this.stopCamera()
    },
    onError(error) {
      console.log('On Error Event', error)
    },
    onStarted(stream) {
      console.log('On Started Event', stream)
    },
    onStopped(stream) {
      console.log('On Stopped Event', stream)
    },
    onCameras(cameras) {
      this.devices = cameras
      console.log('On Cameras Event', cameras)
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    capturePhoto() {
      try {
        this.isSave = true
        this.isStart = false
        if (this.$refs.webcam) {
          this.capturedImage = this.$refs.webcam.capture()
        }
      } catch (e) {
        console.error('Capture Photo', e)
      }
    },
    stopCamera() {
      try {
        this.isSave = false
        this.isStart = false
        if (this.$refs.webcam) {
          this.$refs.webcam.stop()
        }
      } catch (e) {
        console.error('Stop Camera', e)
      }
    },
    startCamera() {
      try {
        this.isSave = false
        this.isStart = true
        if (this.$refs.webcam) {
          this.$refs.webcam.start()
        }
      } catch (e) {
        console.error('Start Camera', e)
      }
    },
    close() {
      this.$emit('close')
    },
    save() {
      if (this.capturedImage) {
        this.$emit('save', {
          row: this.show.row,
          image: this.capturedImage,
        })
      } else {
        alert('Please snap a photo first.')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
  position: relative;
}
.custom-close {
  text-align: right;
  position: absolute;
  right: -20px;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-image {
  width: 120px;
  height: 174px;
  padding-left: 20px;
}
.custom-image-2 {
  width: 192px !important;
}
.custom-pill {
  color: rgb(197, 128, 0);
  background-color: #c4c4c4 !important;
}
.custom-pill-position {
  position: absolute;
  top: 5px;
  left: 10px;
}
.custom-name {
  font-weight: 500;
  font-size: 1.2em;
}
.custom-static-image {
  position: relative;
}
.custom-actions {
  display: inline-flex;
}
.custom-select-camera {
  width: 320px;
}
</style>
